import { createFileRoute } from '@tanstack/react-router'
import ChildTablePage from '@/pages/ChildsPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/records/child/')({
    component: ChildTablePage,
})